import { type ColumnItem, FileBrowserColumn } from "../FileBrowserColumn";

type Props = {
  selectedId: string | null;
  focusedColumn: boolean;
  focusedIndex: number;
  columnIndex: number;
  onSelect: (id: string, label: string, rowIndex: number) => void;
  onReplace?: (id: string, label: string) => void;
  onRegisterCount: (columnIndex: number, count: number) => void;
};

const ITEMS: ColumnItem[] = [
  { id: "chats", label: "Chats", icon: "ask" },
  { id: "workflows", label: "Workflows", icon: "product-workflows" },
];

export function PersonalSectionColumn(props: Props) {
  return <FileBrowserColumn heading="Personal" items={ITEMS} {...props} />;
}
